import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class SrcMappingBrokerCode {

  @JsonProperty()
  id: number;

  @JsonProperty()
  sourceCode: string | undefined;

  @JsonProperty()
  crystalExchangeCode: string | undefined;

  @JsonProperty()
  sourceBrokerCode: string | undefined;

  @JsonProperty()
  crystalBrokerCode: string | undefined;

  @JsonProperty()
  source: string | undefined;

  @JsonProperty()
  modificationDate: DateTime = DateTime.now();

}
